import { useState } from "react";
import intl from "react-intl-universal";
import { ScreenGreeting, StablesQuotesSection } from "../../../Components/Molecules";
import { useAuth } from "../../../Contexts/AuthContext";
import { StablesBalanceCards } from "./StablesBalanceCards";
import { StablesDepositarModal } from "./StablesDepositarModal";
import { StablesHistoryPanel } from "./StablesHistoryPanel";
import { StablesOperationsMenu } from "./StablesOperationsMenu";
import { StablesWalletGate } from "./StablesWalletGate";
import { useStablesPageData } from "./useStablesPageData";

export const StablesHome = ({ historyTab = "all" }) => {
  const { hasPermission } = useAuth();
  const canOperate = hasPermission("stablesoperate");
  const [depositarModalOpen, setDepositarModalOpen] = useState(false);
  const {
    brlBalance,
    brlBalanceFormatted,
    loadingBalance,
  } = useStablesPageData();

  return (
    <div className="w-full">
      <StablesWalletGate>
        <StablesQuotesSection showViewAll={false} />

        <ScreenGreeting
          title={intl.get("stables.title")}
          subTitle={intl.get("stables.subtitle")}
        />

        <section className="mb-6 min-w-0 overflow-hidden">
          <h2 className="mb-3 text-sm font-bold text-brand-dark">{intl.get("stables.operations")}</h2>
          <StablesOperationsMenu
            onOpenDepositar={canOperate ? () => setDepositarModalOpen(true) : undefined}
            depositarActive={depositarModalOpen}
            canOperate={canOperate}
          />
        </section>

        <StablesBalanceCards
          brlBalance={brlBalance}
          brlBalanceFormatted={brlBalanceFormatted}
          loadingBalance={loadingBalance}
        />

        <StablesHistoryPanel
          historyType="general"
          title={intl.get("stables.generalHistory")}
          historyTab={historyTab}
          useHistoryRoutes
        />

        {canOperate ? (
          <StablesDepositarModal
            open={depositarModalOpen}
            onClose={() => setDepositarModalOpen(false)}
          />
        ) : null}
      </StablesWalletGate>
    </div>
  );
};
